module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5cfbf7dc7a981276289e7d911cb142c3.png";